/**
 * 资金账户
 */
export default {
  namespaced: true,
  state: {
    orderId: localStorage.getItem('orderId'), //  订单号
    card_num: '', // 银行卡号
    bindingCardId: '',
  },
  mutations: {
    updateState(state, obj) {
      for (const key in obj) {
        state[key] = obj[key];
      }
    },
  },
  actions: {

  },
  getters: {
    // nextStep: (state) => {
    //   return state.nextStep
    // },
  },
};
